const getTime = require('mn-utils/time');
let _id = 0;

module.exports = () => {
  _id++;
  return `${_id}_${getTime()}`;
};
